import { useTranslation } from "react-i18next";
import { handleLoginOTP, handleRequestOPT } from "../api";
import { AuthResponse, STATES_TYPE, UploadFile,  } from "../types/type";
import React, { Dispatch, SetStateAction, useRef, useState } from "react";


interface ValidOTProps {
  email: string;
  uploadFiles: UploadFile[], 
  setStateUI: Dispatch<SetStateAction<STATES_TYPE>>;
  setLoadOnly: Dispatch<SetStateAction<boolean>>;
  setDataAuth: Dispatch<SetStateAction<AuthResponse>>;
  setWorkspaceData: Dispatch<SetStateAction<any>>;
  setUploadFiles: Dispatch<SetStateAction<UploadFile[]>>,
  setShowProgress: Dispatch<SetStateAction<boolean>>,
  setWorkspaceId: Dispatch<SetStateAction<string | "">>,
}


// const ValideOTPComponent = () => {
const ValideOTPComponent: React.FC<ValidOTProps> = ({ setStateUI, email, uploadFiles, setLoadOnly, setDataAuth, setWorkspaceData, setUploadFiles, setShowProgress, setWorkspaceId }) => {
  
    const { t } = useTranslation();
  
    const [code, setCode] = useState<string[]>(new Array(6).fill(""));
    const inputsRef = useRef<(HTMLInputElement | null)[]>([]);
  
    const handleChange = (value: string, index: number) => {
      if (/^[a-zA-Z0-9]?$/.test(value)) {
        const newCode = [...code];
        newCode[index] = value;
        setCode(newCode);
  
        // focus suivant si une valeur est entrée
        if (value && index < 5) {
          inputsRef.current[index + 1]?.focus();
        }
      }
    };
  
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
      if (e.key === "Backspace" && !code[index] && index > 0) {
        inputsRef.current[index - 1]?.focus();
      }
    };

    const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>, index: number) => {
      e.preventDefault();
      const pasteData = e.clipboardData.getData("text").trim();
      const validChars = pasteData.replace(/[^a-zA-Z0-9]/g, "").split("");

      if (validChars.length === 0) return;

      const newCode = [...code];

      for (let i = 0; i < 6 - index && i < validChars.length; i++) {
        newCode[index + i] = validChars[i];
      }

      setCode(newCode);
      
      const nextIndex = Math.min(index + validChars.length - 1, 5);
      inputsRef.current[nextIndex]?.focus();
    };

  
  return (
    <div className="flex justify-center">

    
    <div className="lg:px-[10%] md:px-2 flex flex-col items-start pt-[10%]">
      <h2 className="text-2xl font-bold mb-4">{t("key_title_valid_code")}</h2>
      <p className="mb-8 text-xl">
        {t("key_content_valid_code_text1")} <br/>{t("key_content_valid_code_text2")} <br/>{t("key_content_valid_code_text3")}
      </p>

      <div className="flex gap-2 mb-12">
        {code.map((digit, index) => (
          <input
            key={index}
            ref={(el) => {
              inputsRef.current[index] = el;
            }}
            type="text"
            maxLength={1}
            value={digit}
            onChange={(e) => handleChange(e.target.value, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            onPaste={(e) => handlePaste(e, index)}  // Paste
            className="w-[52px] h-[71px] text-center font-semibold text-2xl uppercase border-2 border-white rounded-lg bg-transparent focus:border-blue-500 outline-none"
          />
        ))}
      </div>
      <button
        onClick={(e) => handleLoginOTP(e, email, code.join("").toUpperCase(), uploadFiles, setStateUI, setDataAuth, setLoadOnly, setUploadFiles, setShowProgress, setWorkspaceId, setWorkspaceData, t)}
        className={`w-full flex justify-center outline-none items-center gap-4 text-center rounded-lg p-4 font-bold text-sm mt-4 ${ code.join("").length === 6 ? "text-white bg-blue-600 hover:bg-blue-700": "bg-gray-200 text-gray-400 cursor-not-allowed"}`}
      >
        {t("key_valid")}
      </button>

      <button
        onClick={(e) => handleRequestOPT(e, email, setStateUI, t)}
        className={`w-full underline flex justify-center outline-none items-center text-center text-white mt-4`}
      >
        {t("key_resend_valid_code")}
      </button>
    </div>

    </div>
  );
};

export default ValideOTPComponent;
